<div class="body_container">
  <app-component-navigation></app-component-navigation>
  <div class="row h-97 w-100 ms-1">
    <div class="w-100 d-flex flex-column h-100 p-0">
      <!-- <div class="topPanel mb-2">
        <h4
          title="Syncstore - Persistent storage"
        >
          <span class="bi bi-hdd-fill mb-0"></span> {{ activeStorage }}
        </h4>
        <button
          type="button"
          class="default-btn"
          title="Refresh Details"
          (click)="refreshComponent()"
        >
          <span class="bi bi-arrow-clockwise"></span>
          Refresh
        </button>
      </div> -->
      <div class="flex-grow-1 h-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
